// extracted by mini-css-extract-plugin
export var active = "_2v-2";
export var errorDot = "_2v-3";
export var sideNavContainer = "_2v-0";
export var sideNavLink = "_2v-1";